namespace GeniuzPOS.Product {
    export interface CsDocTypeForm {
        DocType: Serenity.StringEditor;
        DocName: Serenity.StringEditor;
        DocPrefix: Serenity.StringEditor;
        DocGroup: Serenity.StringEditor;
        CODE: Serenity.StringEditor;
    }

    export class CsDocTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsDocType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsDocTypeForm.init)  {
                CsDocTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsDocTypeForm, [
                    'DocType', w0,
                    'DocName', w0,
                    'DocPrefix', w0,
                    'DocGroup', w0,
                    'CODE', w0
                ]);
            }
        }
    }
}
